import React, { Fragment } from 'react';

const About = () => (
  <Fragment>
    <h1>About this app</h1>
    <p>An app to find Github users.</p>
  </Fragment>
);

export default About;
